import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20spy%20scene%20with%20a%20mysterious%20figure%20in%20silhouette%20standing%20on%20a%20rooftop%20at%20night%2C%20dramatic%20city%20skyline%20with%20warm%20amber%20and%20crimson%20neon%20lights%2C%20atmospheric%20fog%2C%20film%20noir%20aesthetic%2C%20rain-slicked%20streets%2C%20cinematic%20composition%2C%20intense%20moody%20atmosphere%2C%20professional%20film%20photography%20style&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="赤裸特工 - 官方正版落地页"
        title="赤裸特工 - 间谍动作剧推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6">
        <div className="animate-fade-in-down">
          <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-medium bg-accent-500/90 text-background-50 rounded-full mb-6 tracking-wider">
            官方正版 · 重磅推荐
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 mb-6 leading-tight animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          赤裸特工
        </h1>

        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          融合动作、悬疑与间谍元素的热门作品，集结顶尖卡司与烧脑剧情，
          带你深入特工世界的隐秘角落
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <Link
            to="/category/watch-guide"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看
          </Link>
          <Link
            to="/category/plot"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-background-50/10 text-background-50 border border-background-50/30 rounded-lg hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap backdrop-blur-sm"
          >
            <i className="ri-movie-2-line mr-2"></i>
            了解剧情
          </Link>
        </div>

        <div className="mt-20 grid grid-cols-3 gap-6 md:gap-10 max-w-lg mx-auto animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          {[
            { value: '50亿+', label: '累计播放量' },
            { value: '9.2', label: '豆瓣评分' },
            { value: '150+', label: '覆盖国家' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-300 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-pulse-soft">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}